import React from "react";
import { Box, Card, CardContent, Skeleton } from "@mui/material";

const CultureHubCardSkeleton = ({
  titleWidth = "60%",
  formatWidth = "30%",
}) => (
  <Card
    elevation={0}
    sx={{
      borderRadius: "8px",
      border: "1px solid #E2E2E3",
      boxShadow: "none",
      height: "96px",
    }}
  >
    <CardContent
      sx={{
        height: "100%",
        padding: "16px",
        "&:last-child": { paddingBottom: "16px" },
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Skeleton
          variant="rounded"
          animation="wave"
          width={titleWidth}
          height={20}
        />
        <Skeleton
          variant="rounded"
          animation="wave"
          width={40}
          height={24}
          sx={{ flexShrink: 0 }}
        />
      </Box>
      <Skeleton
        variant="rounded"
        animation="wave"
        width={formatWidth}
        height={16}
      />
    </CardContent>
  </Card>
);

export default CultureHubCardSkeleton;
